import type { ReactNode } from 'react';
import { Children, Fragment, cloneElement, isValidElement } from 'react';

import type { IconProps } from '../icon/icon.types';

export function iconWithProps(icon: ReactNode, label?: string) {
  return Children.map(icon, (child) => {
    if (isValidElement<Partial<IconProps>>(child) && child.type !== Fragment) {
      const altText = child.props.altText || label;
      const color = child.props.color || 'inherit';
      return cloneElement(child, {
        altText,
        color,
      });
    }
    return child;
  });
}
